import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {RequestGetTaxExemption, ResponseGetTaxExemption, TaxExemptionTaxYear} from './taxexemption.dto';

@Injectable()
export class TaxexemptionApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'taxexemption';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public gettaxexemption(payload: RequestGetTaxExemption): Observable<ResponseGetTaxExemption[]> {
    const method: string = 'GET';
    const func: string = 'gettaxexemption';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetTaxExemption[]>(method, url, params, urlParams, body);
  }

  public getlistyeartax(): Observable<TaxExemptionTaxYear[]> {
    const method: string = 'GET';
    const func: string = 'getlistyeartax';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<TaxExemptionTaxYear[]>(method, url, params, urlParams, body);
  }

  public savetaxexemption(payload: ResponseGetTaxExemption[]): Observable<any> {
    const method: string = 'POST';
    const func: string = 'savetaxexemption';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/taxexemption.api.ts